// True while the page is being prerendered (Node) or hydrating prerendered
// HTML in the browser. Animated components use it to render their final,
// visible state so prerendered content is never hidden behind opacity:0.
// App flips it to false once hydration has committed.
export const ssr = { prerender: typeof window === "undefined" };
